import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import handleHospital from "@/services/modules/hospital";

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const cagPdf = () => {
    const { dateOfBarthConvertToAge } = handleHospital();

    const exportToPDF = async (company, ipdData, noteTypes) => {
        const patientData = ipdData.patient;
        const imagePath = await loadImageAsBase64('/app-assets/images/hospital/cag_pci.png');

        var doc = {
            pageSize: 'A4',
            pageMargins: [ 25, 25, 25, 100 ],
            footer: function(currentPage, pageCount) {
                if(currentPage === 1) {
                    return getFooterOperator(ipdData.admitted_by_user);
                }

                if (currentPage === pageCount) {
                    return getFooter(ipdData.admitted_by_user, company);
                }
            },
            content: getContent(patientData, ipdData, noteTypes, imagePath, company),
            styles : {
                header: { fontSize: 24 },
                sectionHeader: { bold: true, fontSize: 16, margin: [0, 15, 0, 10] },
                sectionSubHeader: { bold: true, fontSize: 12 }
            },
            defaultStyle: {
                color: 'black',
                fontSize: 10,
                font: 'SulaimanLipi'
            },
            info: {
                title: 'CAG PCI Report',
            }
        }

        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }

    const getContent = (patientData, ipdData, noteTypes, imagePath, company) => {
        return [
            ...getPatientTable(patientData, ipdData, company),
            ...formatNotesToPdfContent(noteTypes, imagePath, ipdData.operation_doctors_data || ipdData.human_resource)
        ];
    }

    const getPatientTable = (patientData, ipdData, company) => {
        return [{
            image: company.cover_photo64,
            width: 550,
            alignment: 'center',
        },
        {
          table: {
            widths: ['20%', '*', '*', 'auto', '*', 'auto', '*'],
            body: [
              // Row 1: Patient's Name | Sex | Age 
              [
                { text: "Patient's Name :", alignment: 'left' },
                { text: patientData.full_name || '', colSpan: 2 }, {},
                { text: 'Sex', alignment: 'left' },
                { text: patientData.gender || '', alignment: 'left' },
                { text: 'Age', alignment: 'left' },
                { text: calculateAge(patientData.birthday) || '', alignment: 'left' }
              ],

              // Row 2: Date of Procedure | Ward No. | Bed No.
              [
                { text: 'Date of Procedure.', alignment: 'left' },
                { text: ipdData.admission_date || '', colSpan: 2 }, {},
                { text: 'Ward/Bed.', alignment: 'left' },
                {
                      text: ipdData.ward_bed_details, alignment: 'left', colSpan: 3
                }, {}, {},
              ],

              // Row 3: Reg. No. | CD No. | Contact No.
              [
                { text: 'Hospital ID.', alignment: 'left' },
                { text: ipdData.hospital_ref || '', alignment: 'left' },
                { text: 'CD No.', alignment: 'left' },
                { text: ipdData.meta_data.media_cd_no || '', alignment: 'left' },
                { text: 'Contact No.', alignment: 'left' },
                { text: patientData.mobile_no || '', alignment: 'left', colSpan: 2 }, {}
              ]
            ]
          },
          margin: [0, 10, 0, 10],
          layout: {
            hLineWidth: () => 1,
            vLineWidth: () => 1,
            hLineColor: () => '#000',
            vLineColor: () => '#000'
          }
        }, 

        {
          table: {
            widths: ['*', '*', '*', '*', '*'],
            body: [
              [
                { text: 'Height (cm): ' + ipdData.phc_general.height, alignment: 'left', },
                { text: 'Weight (kg): ' + ipdData.phc_general.weight, alignment: 'left', },
                { text: 'Hip/Waist Ratio: ' + ipdData.phc_general.hip_weist_ratio, alignment: 'left' },
                { text: 'BSA (m\u00B2): ' + (ipdData.phc_general.bsa ? ipdData.phc_general.bsa : ''), alignment: 'left', noWrap: true },
                { text: 'BMI: ' + ipdData.phc_general.bmi, alignment: 'left', noWrap: true },

              ]
            ]
          },
          margin: [0, 5, 0, 10],
          layout: 'noBorders'
        }]
    };

    const formatNotesToPdfContent = (noteSections, imagePath, operator) => {
        const content = [];

        noteSections.forEach((section, index) => {
            // Section title
            const noteType = section.notes.find(
                note => note.value === 'approach_type' || note.value === 'interventions_type'
            );
            content.push(...getTitleText(section, noteType));

            // Notes under the section
            section.notes.forEach(note => {
                if (noteType && note.value === noteType.value) return;

                const label = note.label;
                const value = note.note_names.join(', ') || '';
                content.push(getNoteLabel(label, value, note.value));
            });
            
            if (index === 2) {
                const operatorNames = Array.isArray(operator) 
                    ? (operator.length > 0 ? operator[0].name : '')
                    : (operator ? operator.name : '');

                content.push({ text: 'Operators: ' + operatorNames, bold: true, fontSize: 12 })
                content.push({
                    pageBreak: 'before',
                    stack: [
                        {
                            text: 'Operators: ' + operatorNames,
                            bold: true,
                            fontSize: 12
                        },
                        {
                            image: imagePath,
                            width: 500,
                            margin: [0, 10, 0, 10],
                            alignment: 'center'
                        }
                    ]
                });
            }
        });
      
        return content;
    };

    const getTitleText = (section, noteType) => {
            if (noteType && noteType.note_names.length) {
                let isApproach = section.title === 'Approach';
                return [
                    {
                      text: [
                        { text: section.title + ': ', style: isApproach ? 'sectionSubHeader' : 'sectionHeader' },
                        { text: noteType.note_names.join(', ') }
                      ],
                      margin: [0, 15, 0, 10]
                    },
                ];
            }
            
            //For Diagnosis
            if( section.title === 'Diagnosis' && section.notes.length > 0 && false) {
                return [
                    {
                        columns: [
                            {
                                text: section.title + ':',
                                style: 'sectionSubHeader',
                                width: '60%'
                            },
                            {
                                text: section.notes[0].label + ' : ' + section.notes[0].note_names.join(', '),
                            },
                            {
                                text: section.notes[1].label + ' : ' + section.notes[1].note_names.join(', '),
                            }
                        ],
                        margin: [0, 5, 0, 10]
                    },
                ];
            }

            //For other sections
            if (section.title === 'Diagnosis'){
                return [];
            }
            return [
                {
                  text: section.title + ':',
                  style: 'sectionHeader',
                },
            ];
    }

    const getNoteLabel = (label, value, type) => {
        let formattedValue = value;

        if (['balloon_pre_d', 'stent_name'].includes(type) && value) {
            const values = value.split(',').map(v => v.trim());
            formattedValue = values.map((v, i) => `(${i + 1}) ${v}`).join('  ');
        }

        return {
            text: [
                { text: `${label}: `, style: type == 'result' ? 'sectionHeader' : 'sectionSubHeader' },
                { text: formattedValue, fontSize: 10 }
            ],
            margin: [0, 0, 0, 10]
        };
    };

    const loadImageAsBase64 = (url) => {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.onload = function () {
              const reader = new FileReader();
              reader.onloadend = function () {
                resolve(reader.result);
              };
              reader.readAsDataURL(xhr.response);
            };
            xhr.onerror = reject;
            xhr.open('GET', url);
            xhr.responseType = 'blob';
            xhr.send();
        });
    };

    const getFooter = (data, company) => {
        return {
            margin: [ 25, 0 ],
            columns: [
                {
                    alignment: 'right',
                    margin: [0, 33, 20, 0],
                    stack: [
                        {
                            text: data.service_resource_user ? data.service_resource_user.short_description : '',
                            fontSize: 11,
                            bold: true
                        },
                        {
                            text: data.service_resource_user ? data.service_resource_user.full_description : '',
                        }
                    ]
                }
            ]
        }
    }
    
    const getFooterOperator = (admittedByUser) => {
        return {
            margin: [0, 50, 0, 0],
            columns: [
                {
                    alignment: 'center',
                    stack: [
                        {
                            text: admittedByUser.service_resource_user ? admittedByUser.service_resource_user.name : '',
                            fontSize: 12,
                            bold: true
                        }
                    ]
                }
            ]
        }
    }

    const calculateAge = (birthday) => {
        const { year } = dateOfBarthConvertToAge(birthday)
        return `${year} Years`
    };

    return {
        exportToPDF
    }
}

export default cagPdf;